import Create from "./Create";
import Edit from "./Edit";
import List from "./List";

const routes = [
    {
        path: 'customers',
        element: <List />
    },
    {
        path: 'customers/create',
        element: <Create />
    },
    {
        path: 'customers/edit/:id',
        element: <Edit />
    }
]
export default routes;